import { config } from '../_config';
import { IUpdateService } from '../_types/IUpdates';
import {updateService as updateS} from './update.service';
import {updateService as updateFS} from './fake.update.service';

export let updateService: IUpdateService;

if (config.useFake === true) {
    updateService = updateFS;
} else {
    updateService = updateS;
}